import { i18n } from 'i18n';

export interface ActivePoursPageParams {
    entityId: string;
  }

export const ROUTE_PATH = '/active-pours';
export const TITLE = i18n._('Active Pours');
